var mapShippingRatesToStripe = function mapShippingRatesToStripe(internalRates) {
  return internalRates.map(function (rate) {
    var id = rate.identifier,
      displayName = rate.label,
      amount = rate.amount;
    var validFormat = /^[0-9]*\.[0-9]{2}$/.test(amount);
    var safeAmount = validFormat ? Number(amount.replace('.', '')) : 0;
    return {
      id: id,
      displayName: displayName,
      amount: safeAmount
    };
  });
};
export { mapShippingRatesToStripe as default };